<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    class="modal-library-search-details"
  >
    <v-card>
      <v-toolbar color="white" elevation="0" class="content-header">
        <v-btn icon plain :ripple="false" @click="$emit('close')">
          <Back />
        </v-btn>
        <v-toolbar-title class="toolbar-title">
            <h2 class="fs-16">검색</h2>
        </v-toolbar-title>
      </v-toolbar>
      <v-container fluid class="pt-0">
        <div class="search-area mb-3">
          <img :src="getImage('ic_search.svg')" class="search-icon" />
          <input type="text" class="search-input" placeholder="검색해보세요."
                v-model="searchText"
                @click="getCookieArray()"
                @keyup.enter="goSearch()"/>
        </div>
        <!-- 검색 결과가 있을경우 -->
        <div class="results-list">
            <!-- 검색 결과가 없는경우 -->
            <template v-if="searchList.length === 0">
              <div class="no-data">
                  <span>검색 결과가 없습니다.</span>
              </div>
            </template>
            <template v-else>
            <div class="d-flex justify-space-between align-center search-delete">
                <span>최근 검색어</span>
                <v-btn text :ripple="false" class="btn-delete" @click="delCookie()">전체삭제</v-btn>
            </div>
            <ul class="search-result pa-0">
                <li class="d-flex justify-space-between align-center mb-3"
                    v-for="(item, index) in searchList"
                    :key="index">
                  <div class="name" @click="goSearch(item.scText)" v-text="item.scText"></div>
                  <v-btn icon plain :ripple="false" class="btn-close" @click="delCookie(item)">
                    <Close/>
                  </v-btn>
                </li>
            </ul>
            </template>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import Back from "@/components/icons/Back";
import Close from "@/components/icons/Close";
import VueCookies from 'vue-cookies'
import store from '../../store'
export default {
  props: {
    dialog: Boolean,
  },
  data: ()=> ({
    searchText: '',
    searchTextOption: 'content',
    searchfinish: false,
    contentlist: [],
    searchList: [],
    cookieKey: 'ckLibSearch'
  }),
  components: {
    Back,
    Close,
  },
  created () {
    this.getCookieArray(this.cookieKey)
  },
  methods:{
    search(){
        this.movePage('/fo/library/searchResults');
    },
    getCookieArray: function() {
        this.searchList = [];

          if (VueCookies.isKey(this.cookieKey)) {
              var str = VueCookies.get(this.cookieKey);

              if (str != null) {
                  var cookieList = [];
                  cookieList = str.split("|，|");
                  var item = [];
                  cookieList.forEach((ele, idx) => {
                      item = {
                          scId: idx,
                          scText: ele
                      }

                      this.searchList.push(item)
                  });
              } else {
                  console.log('쿠키 데이터 없음')
              }

          } else {
              console.log('쿠키 없음')
          }
    },
    delCookie: function(citem) {

        if (citem) {
            if (VueCookies.isKey(this.cookieKey)) {
                var getCookies = VueCookies.get(this.cookieKey);
                if (getCookies != null) {
                    VueCookies.remove(this.cookieKey); // 쿠키 삭제

                    var cookieList = [];
                    cookieList = getCookies.split("|，|");

                    var strCookies = "";
                    cookieList.forEach((ele, idx) => {
                        if (idx == citem.scId && ele == citem.scText) {
                            return;
                        } else {
                            if(strCookies != "" )  strCookies += "|，|";
                            strCookies += ele;
                        }
                    });
                    VueCookies.set('ckLibSearch', strCookies); // 쿠키 재생성
                }
                this.getCookieArray('ckLibSearch'); // 쿠키 재호출 후 화면에 세팅
            } else {
                console.log('getCookieArray 값 없음')
            }
        } else {
            VueCookies.remove(this.cookieKey); // 쿠키 삭제
            this.getCookieArray('ckLibSearch'); // 쿠키 재호출 후 화면에 세팅
        }

    },
    async getCodeList (cdGrp) {
        await store.dispatch('getCodeList', this.$_payload({'cdGrp': cdGrp}))
            .then(res => {
                if (res.success) {
                    this.getLB002Result = res.data;
                } else {
                    console.log(res.msg)
                    this.getLB002Result = ''
                }
            })
            .catch(error => {
                console.error(error)
                this.getLB002Result = ''
            })
            .finally(() => {})
    },
    async goSearch (sText) {
        if (sText != null && sText != '') {
          this.searchText = sText;
        }
        await store.dispatch('getLibraryList', this.$_payload('so',[{ 'searchText': this.searchText }, { 'searchTextOption': 'content' }]))
            .then(res => {
                if (res.success) {
                    this.contentlist = res.data.content;
                    this.searchfinish = true;

                    this.setCookie();

                    if (this.$route.name === '도서관 검색 결과') {
                        this.$emit('close', this.contentlist);
                    } else {
                        this.$router.push({name: '도서관 검색 결과', params: {'contentlist': this.contentlist}})
                    }
                } else {
                    console.log(res.msg)
                    this.contentlist = ''
                    this.searchfinish = ''
                }
                })
                .catch(error => {
                    console.error(error)
                    this.contentlist = ''
                    this.searchfinish = ''
                })
                .finally(() => {
                })
    },
    setCookie : function() {
        // console.log('setCookie = ' + this.searchText);
        var str = this.searchText;
        var arrCookies = [];

        if (VueCookies.isKey('ckLibSearch')) {
            // cArray = this.getCookieArray('ckLibSearch');

            var getCookies = VueCookies.get('ckLibSearch');

            if (getCookies != null) {
                arrCookies = getCookies.split("|，|");

                for ( var key = 0; key < (arrCookies.length < 9 ? arrCookies.length : 9); key++ ) {
                    if(str != "" )  str += "|，|";
                    console.log(key);
                    str += arrCookies[key];
                }
            }

        } else {
            console.log('finally 값 없음')
        }

        VueCookies.set('ckLibSearch', str);
        this.getCookieArray('ckLibSearch');
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
